import { render } from "./MailModal.vue?vue&type=template&id=1d12fb14"
import script from "./MailModal.vue?vue&type=script&lang=js"
export * from "./MailModal.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3809301774/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__